import React from 'react';
import { LuSearch } from "react-icons/lu";


const SearchBar = ({ searchTerm, onSearch }) => {
  return (
    
    <div className="flex justify-center mb-5">
      <div className="flex items-center border-gray-300 w-4/5 h-15 font-semibold border-2 rounded-2xl pl-4">
        <LuSearch className="text-gray-500 text-2xl" />
        <input
          type="text"
          placeholder="Search user"
          value={searchTerm}
          onChange={onSearch}
          className="h-full w-4/5 px-4 py-2 outline-none"
        />
      </div>
    </div>
  );
};

export default SearchBar;
